// Map Vue Router route names to human-readable page names
// Route names come from router/index.ts and are PascalCase
export const PAGE_NAMES: Record<string, string> = {
  // Admin
  AdminDashboard: "Admin - Campaigns",
  // AI
  AIChat: "AI Assistant",
  CampaignFields: "Admin - Field Mappings",
  Campaigns: "Campaigns",
  CampaignWithRA: "Campaign Details",
  CaseAssets: "Case Documents",
  CaseDetail: "Case Details",
  ContentCleaning: "Admin - Content Cleaning",
  CrmAdmin: "Admin - CRM Config",
  // Main
  Dashboard: "Dashboard",
  DeepInsightDetail: "Deep Insight Details",
  DeepInsights: "Deep Insights",
  EditCampaign: "Admin - Edit Campaign",
  FirmDetail: "Firm Details",
  // Firms
  Firms: "Firms",
  MagicLinkRedeem: "Magic Link",
  // Reports
  Reports: "Reports",
  // Auth
  SignIn: "Sign In",
  SingleCampaign: "Campaign Details",
  StandardFields: "Admin - Standard Fields",
  // Superadmin
  SuperadminDashboard: "Superadmin Dashboard",
  SuperadminMagicLinks: "Superadmin - Magic Links",
  SuperadminOrganizations: "Superadmin - Organizations",
  SuperadminSmartFields: "Superadmin - Smart Fields",
  SuperadminUsers: "Superadmin - Users",
  TwoStepVerification: "Verify Code",
};

export function getPageName(routeName: string): string {
  return PAGE_NAMES[routeName] || routeName;
}
